import { useCallback, useRef, useState } from 'react';
import { shouldShowEditWarningModal } from '@app/components/modals/edit-warning';

export default function useTemplateEditWarningModal(agreement: Oneflow.Agreement) {
  const [isOpen, setIsOpen] = useState(false);
  const hasShown = useRef(false);

  const openModal = useCallback(() => {
    queueMicrotask(() => {
      setIsOpen(true);
      hasShown.current = true;
    });
  }, []);

  // When user clicks somewhere in the box list, the pointer down event is triggered
  // We need to prevent the default behavior in the capture phase to avoid menus and such from opening
  const handlePointerDownCapture = useCallback(
    (e: React.PointerEvent<HTMLElement>) => {
      if (shouldShowEditWarningModal(agreement) && !hasShown.current) {
        e.preventDefault();
        openModal();
      }
    },
    [
      agreement,
      openModal,
    ],
  );

  // When user navigates to the box list using the keyboard, the focus event is triggered
  // We need to handle this event to show the modal
  const onFocus = useCallback(
    (e: React.FocusEvent<HTMLElement>) => {
      if (shouldShowEditWarningModal(agreement) && !hasShown.current) {
        e.preventDefault?.();
        openModal();
      }
    },
    [
      agreement,
      openModal,
    ],
  );

  const closeModal = useCallback(() => setIsOpen(false), []);

  return {
    isOpen,
    handlePointerDownCapture,
    onFocus,
    closeModal,
  };
}
